import React from 'react';
import { Radio } from 'lucide-react';
import { PersistedWorkflow } from '@cotera/sdk/core';
import { Text } from '@cotera/client/app/components/ui';
import type {
  WorkflowEventTriggerViewData,
  WorkflowTriggerRenderStrategy,
  WorkflowTriggerViewData,
} from '../types';

const { PersistedWorkflowTriggerKind } = PersistedWorkflow;

function isEventTrigger(
  trigger: WorkflowTriggerViewData
): trigger is WorkflowEventTriggerViewData {
  return trigger.kind === PersistedWorkflowTriggerKind.Event;
}

export const eventTriggerStrategy: WorkflowTriggerRenderStrategy = {
  triggerKind: PersistedWorkflowTriggerKind.Event,
  accent: 'event',
  badge: 'Event',
  matches: isEventTrigger,
  getTitle: (trigger) =>
    isEventTrigger(trigger) && trigger.name.trim() !== ''
      ? trigger.name
      : 'Event',
  getDescription: (trigger) => {
    if (!isEventTrigger(trigger)) {
      return undefined;
    }
    const eventName = trigger.eventName.trim();
    if (eventName === '') {
      return 'No event name configured';
    }
    // Avoid repeating the event name when the trigger name already matches it.
    if (trigger.name.trim() === eventName) {
      return undefined;
    }
    return eventName;
  },
  renderIcon: () => <Radio className="h-4 w-4" />,
  renderBody: (trigger) => {
    if (!isEventTrigger(trigger)) {
      return null;
    }
    const eventName = trigger.eventName.trim();
    return (
      <Text.Caption className="text-muted-foreground block truncate">
        {eventName !== '' ? `Listens for “${eventName}”` : 'No event name'}
      </Text.Caption>
    );
  },
};
